// Bilingual content map for GlassCore website
export const translations = {
  ro: {
    common: {
      brand: "GlassCore",
      cta_primary: "Solicită o discuție tehnică",
      cta_specialist: "Discută cu un specialist",
      cta_solutions: "Vezi soluțiile GlassCore",
      cta_discuss: "Discută această soluție cu GlassCore",
      cta_short: "Discută cu GlassCore",
      lang_ro: "RO",
      lang_en: "EN",
      email: "office@glasscore.ro",
      phone: "+40 723 347 165",
      phone_href: "tel:+40723347165",
      address_placeholder: "[adresă companie]",
      back_home: "Înapoi la pagina principală",
      menu_open: "Deschide meniul",
      menu_close: "Închide meniul",
    },
    nav: {
      home: "Acasă",
      about: "Despre",
      solutions: "Soluții",
      expertise: "Expertiză",
      applications: "Aplicații",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Furnizor de antrepriză B2B",
      title_line1: "Soluții complete",
      title_line2: "construite în jurul",
      title_line3: "sticlei.",
      subtitle:
        "Furnizor de antrepriză specializat în sticlă, sisteme și componente conexe pentru proiecte B2B de construcții.",
      paragraph:
        "Lucrăm cu dezvoltatori, antreprenori, arhitecți și proiectanți care au nevoie de soluții vitrate corect specificate, competitive și fezabile în execuție. Pornim de la sticlă ca element central și integrăm în jurul ei consultanța tehnică, sourcingul, produsele, sistemele, logistica și suportul de implementare.",
      stat_1_value: "B2B",
      stat_1_label: "Antrepriză specializată",
      stat_2_value: "INT'L",
      stat_2_label: "Sourcing internațional",
      stat_3_value: "360°",
      stat_3_label: "Produs · sistem · suport",
      scroll: "Scroll",
    },
    marquee: [
      "Geam termoizolant",
      "Fațade vitrate",
      "Tâmplării aluminiu",
      "Balustrade",
      "Sticlă laminată",
      "Sticlă securizată",
      "Sourcing internațional",
      "Consultanță tehnică",
      "Compartimentări",
      "Sticlă specială",
      "Accesorii & profile",
    ],
    about: {
      eyebrow: "Cine suntem · 01",
      title: "Furnizor de antrepriză specializat în sticlă",
      p1: "GlassCore este o companie specializată în soluții din sticlă pentru construcții, adresată mediului business to business. Integrăm produse, sisteme și servicii într-o abordare completă, de la consultanță și sourcing până la livrare, coordonare și suport de implementare.",
      p2: "Nu tratăm sticla ca marfă generică. O tratăm ca material tehnic, cu implicații directe asupra performanței, siguranței, esteticii, montajului și durabilității unei construcții.",
      bullets: [
        "Specializare în sticlă pentru construcții",
        "Sourcing internațional organizat",
        "Soluții complete, nu produse izolate",
        "Consultanță tehnică aplicată",
        "Integrare cu sisteme, profile și accesorii",
        "Suport pentru proiecte B2B",
      ],
    },
    process: {
      eyebrow: "Ce facem · 02",
      title: "De la sticlă la soluția completă",
      lead: "În proiectele de construcții, sticla nu funcționează singură. Ea trebuie corelată cu sistemul de tâmplărie, fațada, prinderile, accesoriile, dimensiunile, greutatea, cerințele de siguranță, performanța termică, acustica, expunerea solară și condițiile reale din șantier.",
      lead2: "GlassCore integrează aceste elemente într-o soluție tehnică și comercială coerentă.",
      steps: [
        { t: "Analiză cerințe proiect", d: "Citim contextul tehnic, comercial și de execuție al proiectului." },
        { t: "Consultanță tehnică", d: "Punem corect întrebările care evită soluții incomplete." },
        { t: "Specificație sticlă & sisteme", d: "Compoziții, grosimi, sisteme conexe și compatibilități." },
        { t: "Sourcing și optimizare", d: "Comparăm producători, termene, costuri și capacitate." },
        { t: "Producție și coordonare", d: "Aliniem cerințele cu realitatea fabricilor partenere." },
        { t: "Logistică și livrare", d: "Manipulare corectă, ambalare și planificare către șantier." },
        { t: "Montaj / suport implementare", d: "Sprijinim execuția și clarificările tehnice din șantier." },
        { t: "Recepție și clarificări", d: "Predare ordonată, cu documentație tehnică relevantă." },
      ],
    },
    solutions: {
      eyebrow: "Soluții · 03",
      title: "Sticlă, sisteme și componente — integrate",
      lead: "Șapte direcții principale prin care GlassCore livrează soluții complete în jurul sticlei.",
      items: [
        {
          k: "01",
          t: "Geam termoizolant",
          d: "Pachete duble și triple, Low-E, control solar, argon, warm edge, sticlă laminată sau securizată, adaptate cerințelor de performanță energetică, siguranță și confort.",
        },
        {
          k: "02",
          t: "Fațade și închideri vitrate",
          d: "Soluții pentru fațade, pereți cortină, vitraje mari și închideri arhitecturale, cu integrarea sticlei, sistemelor și componentelor conexe.",
        },
        {
          k: "03",
          t: "Tâmplării și sisteme din aluminiu",
          d: "Ferestre, uși, sisteme glisante și tâmplării performante, corelate cu tipul de sticlă, dimensiunile, greutatea și cerințele proiectului.",
        },
        {
          k: "04",
          t: "Balustrade din sticlă",
          d: "Soluții pentru balustrade interioare și exterioare, cu sticlă laminată, securizată și sisteme de prindere adaptate aplicației.",
        },
        {
          k: "05",
          t: "Compartimentări și amenajări interioare",
          d: "Pereți despărțitori, uși din sticlă, sisteme glisante și soluții interioare pentru spații office, comerciale și rezidențiale.",
        },
        {
          k: "06",
          t: "Sticlă specială și aplicații custom",
          d: "Sticlă extra-clear, low iron, mid iron, colorată, acustică, solară sau compoziții speciale pentru proiecte cu cerințe tehnice avansate.",
        },
        {
          k: "07",
          t: "Accesorii și componente conexe",
          d: "Profile, sisteme de prindere, feronerie, garnituri, baghete, distanțieri, elemente metalice și componente necesare soluției finale.",
        },
      ],
    },
    expertise: {
      eyebrow: "Expertiză tehnică · 04",
      title: "Sticla trebuie corect specificată, nu doar ofertată",
      lead: "O soluție vitrată corectă începe cu întrebările potrivite: unde se montează, ce dimensiuni are, cum se comportă la spargere, ce performanță termică este necesară, ce expunere solară există, ce nivel de siguranță se cere, ce sistem o susține și cum se va executa în șantier.",
      lead2:
        "GlassCore ajută clienții să evite soluțiile incomplete, incompatibilitățile între produse și deciziile luate exclusiv pe baza prețului.",
      topics: [
        "Comportament la spargere",
        "Sticlă securizată și laminată",
        "Eficiență energetică",
        "Control solar",
        "Acustică",
        "Grosimi și compoziții",
        "Compatibilitate cu tâmplăria",
        "Compatibilitate cu sistemele de prindere",
        "Logistică și manipulare",
        "Fezabilitate în execuție",
      ],
    },
    sourcing: {
      eyebrow: "Sourcing internațional · 05",
      title: "Sourcing internațional și arbitraj între piețe",
      p1: "GlassCore lucrează cu o perspectivă internațională asupra pieței de sticlă și a componentelor conexe. Identificăm soluții competitive din punct de vedere tehnic și comercial, comparând producători, disponibilități, termene, costuri și capacități de producție.",
      p2: "Această abordare ne permite să construim soluții mai bine calibrate pentru proiecte B2B: nu doar mai bune ca preț, ci mai clare ca specificație, mai fezabile în producție și mai potrivite pentru implementare.",
      cards: [
        "Acces la producători specializați",
        "Alternative tehnice și comerciale",
        "Optimizare cost / termen / performanță",
        "Coordonare producție și livrare",
        "Soluții pentru proiecte cu cerințe speciale",
      ],
    },
    applications: {
      eyebrow: "Aplicații · 06",
      title: "Aplicații în proiecte de construcții",
      lead: "GlassCore poate susține proiecte în care sticla are rol arhitectural, funcțional sau tehnic important, de la vitraje termoizolante și tâmplării până la fațade, balustrade, compartimentări și aplicații custom.",
      items: [
        "Ansambluri rezidențiale",
        "Clădiri de birouri",
        "Spații comerciale",
        "Hoteluri și hospitality",
        "Restaurante și săli de evenimente",
        "Showroom-uri",
        "Clădiri publice",
        "Amenajări interioare",
        "Fațade vitrate",
        "Balustrade și terase",
        "Proiecte premium cu cerințe speciale",
      ],
    },
    why: {
      eyebrow: "De ce GlassCore · 07",
      title: "Șase motive pentru care proiectele B2B aleg GlassCore",
      items: [
        { t: "Specializare pe sticlă", d: "Înțelegem materialul, aplicațiile și riscurile tehnice." },
        { t: "Abordare de antrepriză", d: "Integrăm produsul, sistemul, componentele, logistica și suportul." },
        { t: "Sourcing internațional", d: "Căutăm soluții competitive și fezabile pe piețe multiple." },
        { t: "Consultanță tehnică", d: "Ajutăm clientul să specifice corect soluția, nu doar să compare prețuri." },
        { t: "Experiență practică", d: "Înțelegem diferența dintre ofertă, producție, livrare și șantier." },
        { t: "Partener B2B de încredere", d: "Lucrăm structurat, profesionist și orientat spre proiecte reale." },
      ],
    },
    experience: {
      eyebrow: "Experiență · 08",
      title: "Experiență relevantă în piață",
      subtitle:
        "GlassCore reprezintă scalarea maturității profesionale a unei experiențe acumulate în proiecte, ofertări, consultanță tehnică, sourcing și livrări de specialitate în zona sticlei pentru construcții.",
      p1: "GlassCore pornește de la o experiență profesională reală acumulată în piața soluțiilor din sticlă pentru construcții. Echipa din spatele GlassCore a interacționat, de-a lungul timpului, cu dezvoltatori, antreprenori, arhitecți, constructori și companii specializate, în contexte care au implicat ofertare, consultanță tehnică, sourcing, livrări de specialitate sau lucrări de antrepriză.",
      p2: "Această experiență este transpusă astăzi într-o abordare mai clară, mai specializată și mai completă: sticla nu este tratată ca produs izolat, ci ca element central al unei soluții integrate, care include sisteme, componente, accesorii, logistică și suport pentru implementare.",
      p3: "GlassCore exprimă această evoluție profesională: o structură capabilă să integreze expertiza acumulată, relațiile de piață, disciplina tehnico-comercială și capacitatea de antrepriză într-un model coerent pentru proiecte B2B care implică sticlă.",
      grid_label: "Interacțiuni profesionale relevante",
      logos: [
        { name: "Luxuria Residence", src: "/assets/logos/luxuria-mono.png" },
        { name: "One Mircea Eliade", src: "/assets/logos/one-mircea-eliade-mono.png" },
        { name: "Prime Kapital", src: "/assets/logos/prime-kapital-mono.png" },
        { name: "Erbașu", src: "/assets/logos/erbasu-mono.png" },
        { name: "Greenfield Residence", src: "/assets/logos/greenfield-mono.png" },
        { name: "Global Vision", src: "/assets/logos/globalvision-mono.png" },
        { name: "Studium Green", src: "/assets/logos/studium-green-mono.png" },
        { name: "STRABAG", src: "/assets/logos/strabag-mono.png" },
      ],
      disclaimer:
        "Prezența unei sigle indică o interacțiune profesională relevantă cu echipa care dezvoltă GlassCore, în etape precum ofertare, input tehnic, sourcing, livrare de specialitate sau execuție. Aceasta nu implică automat o relație contractuală curentă, un parteneriat oficial sau o recomandare comercială.",
    },
    experience_short: {
      eyebrow: "Experiența care susține GlassCore",
      title: "Experiența care susține GlassCore",
      p1: "GlassCore reprezintă scalarea maturității profesionale a unei experiențe reale acumulate în piața soluțiilor din sticlă pentru construcții. Echipa a fost implicată în contexte B2B care au presupus ofertare, consultanță tehnică, sourcing, livrări de specialitate și antrepriză pentru aplicații în care sticla a avut rol tehnic, arhitectural sau funcțional.",
      p2: "Această experiență este transpusă într-o abordare completă: sticla ca element central, integrată cu sisteme, componente, accesorii, logistică și suport de implementare.",
    },
    final_cta: {
      eyebrow: "Discuție tehnică · 09",
      title: "Ai un proiect care implică sticlă?",
      lead: "Discută cu GlassCore înainte de a bloca specificația, bugetul sau furnizorul. Putem analiza cerințele proiectului și propune o soluție tehnică și comercială coerentă.",
      label_email: "Scrie-ne",
      label_phone: "Sună-ne",
      hours: "Luni — Vineri · 09:00 — 18:00 (EET)",
    },
    footer: {
      tagline: "Soluții complete construite în jurul sticlei.",
      explore: "Navigare",
      contact: "Contact",
      legal: "© {year} GlassCore. Toate drepturile rezervate.",
      built: "Furnizor de antrepriză B2B · Sticlă pentru construcții",
    },
    about_page: {
      eyebrow: "Despre GlassCore",
      title: "Construit în jurul unei competențe clare: sticla pentru construcții.",
      p1: "GlassCore este o companie construită în jurul unei competențe clare: sticla pentru construcții. Experiența noastră combină proiecte reale, colaborări internaționale, sourcing tehnic și înțelegerea etapelor prin care trece o soluție vitrată: specificație, ofertare, producție, transport, montaj și recepție.",
      p2: "Această experiență ne permite să lucrăm ca furnizor de antrepriză specializat, capabil să integreze sticla și toate componentele conexe într-o soluție completă pentru client.",
      principles_title: "Principii de lucru",
      principles: [
        { t: "Tehnic înainte de comercial", d: "Specificăm corect, apoi optimizăm comercial — nu invers." },
        { t: "Soluții, nu produse", d: "Integrăm sticla, sistemul, accesoriile și suportul." },
        { t: "Transparență de execuție", d: "Discutăm cerințele reale ale șantierului, nu doar fișa tehnică." },
        { t: "Sourcing internațional", d: "Comparăm piețele pentru fezabilitate, nu doar preț." },
      ],
    },
    solutions_page: {
      eyebrow: "Soluții",
      title: "Sticla, sistemele și componentele — într-o ofertă integrată.",
      lead: "Categoriile prin care GlassCore livrează soluții complete pentru proiecte B2B de construcții.",
      applications_label: "Aplicații",
      technical_label: "Tehnic",
      categories: [
        {
          k: "01",
          t: "Geam termoizolant",
          d: "Pachete duble și triple cu Low-E, control solar, argon, warm edge, compoziții laminate sau securizate.",
          apps: "Rezidențial, birouri, hospitality, fațade.",
          tech: "Performanță energetică, transmisie luminoasă, factor solar g, Uw, izolare acustică Rw.",
        },
        {
          k: "02",
          t: "Fațade și închideri vitrate",
          d: "Fațade vitrate, pereți cortină, vitraje mari, închideri arhitecturale integrate cu sisteme și prinderi.",
          apps: "Clădiri de birouri, retail, mixed-use, hospitality.",
          tech: "Sisteme structurale, prinderi punctuale, fixare pe profile, etanșări, drenaj.",
        },
        {
          k: "03",
          t: "Tâmplării și sisteme din aluminiu",
          d: "Ferestre, uși, sisteme glisante și tâmplării performante corelate cu tipul, greutatea și dimensiunile sticlei.",
          apps: "Rezidențial premium, birouri, hospitality, restaurante.",
          tech: "Profile termoizolante, garnituri, accesorii, geometrii, statică.",
        },
        {
          k: "04",
          t: "Balustrade din sticlă",
          d: "Balustrade interioare și exterioare cu sticlă laminată / securizată-laminată și sisteme de prindere adecvate.",
          apps: "Terase, scări, balcoane, mezanin, hospitality, retail.",
          tech: "Compoziție laminată, înălțime, încărcare la împingere, tipuri de mâini curente.",
        },
        {
          k: "05",
          t: "Compartimentări interioare",
          d: "Pereți despărțitori din sticlă, uși batante și glisante, soluții acustice pentru spații office și comerciale.",
          apps: "Office, retail, hospitality, rezidențial premium.",
          tech: "Acustică Rw, fixare, profile, etanșări, deschideri ample.",
        },
        {
          k: "06",
          t: "Sticlă laminată și securizată",
          d: "Soluții pentru aplicații cu cerințe ridicate de siguranță și comportament la spargere controlat.",
          apps: "Balustrade, fațade, calcabilă, anti-efracție, parapet.",
          tech: "Folii PVB / SGP, clase de rezistență, comportament reziduale după spargere.",
        },
        {
          k: "07",
          t: "Sticlă specială",
          d: "Sticlă extra-clear, low iron, mid iron, colorată, acustică, control solar, compoziții speciale.",
          apps: "Showroom-uri, retail premium, fațade arhitecturale, proiecte cu cerințe avansate.",
          tech: "Transmisie luminoasă, neutralitate cromatică, performanță solară, contrast vizual.",
        },
        {
          k: "08",
          t: "Accesorii și componente conexe",
          d: "Profile, sisteme de prindere, feronerie, garnituri, baghete, distanțieri, componente metalice.",
          apps: "Toate categoriile, integrate în soluția completă.",
          tech: "Compatibilitate, sarcină, fixare, durabilitate, finisaje.",
        },
        {
          k: "09",
          t: "Antrepriză și suport de implementare",
          d: "Integrare produs, sistem, componente, logistică și suport tehnic pentru execuție.",
          apps: "Proiecte B2B în care sticla are rol tehnic semnificativ.",
          tech: "Coordonare furnizori, etape, documentație tehnică, clarificări de șantier.",
        },
      ],
    },
    expertise_page: {
      eyebrow: "Expertiză",
      title: "Întrebările corecte produc soluții corecte.",
      lead: "Câteva teme pe care le abordăm tehnic înainte de orice ofertare, pentru a reduce riscurile din șantier și deciziile luate exclusiv pe preț.",
      topics: [
        {
          t: "Cum se alege corect sticla",
          d: "Pornim de la aplicație, expunere, dimensiuni, sistem suport și nivelul de siguranță cerut — nu de la prețul pe metru pătrat.",
        },
        {
          t: "Comportament la spargere",
          d: "Sticla securizată se sparge controlat. Sticla laminată rămâne în loc. Cele două se aleg în funcție de aplicație, nu invers.",
        },
        {
          t: "Securizată, laminată, securizată-laminată",
          d: "Trei comportamente diferite, fiecare potrivit altui tip de risc: cădere, calcabilitate, anti-efracție, parapet.",
        },
        {
          t: "Compatibilitate cu tâmplăria",
          d: "Profile, garnituri, greutate, geometrie și deflexii — sticla și sistemul trebuie corelate, nu doar comandate separat.",
        },
        {
          t: "Performanță termică, solară, acustică",
          d: "Uw, factor solar g, transmisie luminoasă, Rw — parametri reali care influențează confortul și consumul.",
        },
        {
          t: "Sourcing tehnic vs. achiziție simplă",
          d: "Sourcingul tehnic compară piețele pe specificație, capacitate, termene și fezabilitate, nu doar pe preț.",
        },
        {
          t: "De ce o soluție completă reduce riscul",
          d: "Sticla, sistemul, accesoriile și suportul corelate într-o singură ofertă elimină incompatibilitățile clasice.",
        },
      ],
      questions_title: "Întrebări tehnice tipice",
      questions: [
        "Unde se montează vitrajul și care este expunerea?",
        "Ce dimensiuni și greutăți sunt implicate?",
        "Ce comportament la spargere este necesar?",
        "Există cerințe acustice sau de control solar?",
        "Ce sistem de tâmplărie sau prindere se folosește?",
        "Cum se manipulează și se montează în șantier?",
      ],
    },
    contact_page: {
      eyebrow: "Contact",
      title: "Discuție tehnică, nu doar o cerere de ofertă.",
      lead: "Pentru solicitări tehnice sau proiecte B2B, transmiteți cât mai multe informații despre aplicație, dimensiuni, sistem, termen și documentația disponibilă. Răspundem rapid, structurat și relevant pentru contextul proiectului.",
      email_label: "Email",
      phone_label: "Telefon",
      address_label: "Adresă",
      hours_label: "Program",
      hours_value: "Luni — Vineri · 09:00 — 18:00 (EET)",
      address_value: "Oradea, Str. Roman Ciorogariu 65, Corp C, Etaj 2, 410009, România",
      checklist_title: "Ce informații ajută într-o primă discuție",
      checklist: [
        "Tipul proiectului (rezidențial, office, hospitality, retail, public)",
        "Stadiul (DTAC, PT, execuție, ofertare)",
        "Aplicații (fațadă, tâmplărie, balustradă, compartimentare, custom)",
        "Dimensiuni indicative și cantități",
        "Cerințe de performanță (termic, solar, acustic, siguranță)",
        "Termene țintă și constrângeri de șantier",
        "Documentație disponibilă (planșe, detalii, specificații)",
      ],
    },
    seo: {
      home_title: "GlassCore — Soluții complete construite în jurul sticlei | Furnizor de antrepriză B2B",
      home_desc:
        "GlassCore este un furnizor de antrepriză specializat în soluții din sticlă pentru construcții: geam termoizolant, fațade, tâmplării aluminiu, balustrade și sticlă specială pentru proiecte B2B.",
      about_title: "Despre GlassCore — Furnizor specializat în sticlă pentru construcții",
      about_desc:
        "Companie specializată în soluții din sticlă pentru construcții B2B. Sourcing internațional, consultanță tehnică, integrare produs și suport de implementare.",
      solutions_title: "Soluții GlassCore — Sticlă, fațade, tâmplării, balustrade, sticlă specială",
      solutions_desc:
        "Geam termoizolant, fațade vitrate, tâmplării aluminiu, balustrade, compartimentări, sticlă laminată, securizată și specială pentru proiecte B2B.",
      expertise_title: "Expertiză — GlassCore | Sticla corect specificată, nu doar ofertată",
      expertise_desc:
        "Cum se alege corect sticla, comportament la spargere, performanță termică, solară și acustică, compatibilitate cu sisteme și suport de implementare.",
      contact_title: "Contact GlassCore — Discuție tehnică pentru proiecte B2B cu sticlă",
      contact_desc:
        "Contactează GlassCore pentru proiecte B2B care implică sticlă. Email office@glasscore.ro, telefon +40 723 347 165.",
    },
  },
  en: {
    common: {
      brand: "GlassCore",
      cta_primary: "Request a technical discussion",
      cta_specialist: "Talk to a specialist",
      cta_solutions: "Explore GlassCore solutions",
      cta_discuss: "Discuss this solution with GlassCore",
      cta_short: "Talk to GlassCore",
      lang_ro: "RO",
      lang_en: "EN",
      email: "office@glasscore.ro",
      phone: "+40 723 347 165",
      phone_href: "tel:+40723347165",
      address_placeholder: "[company address]",
      back_home: "Back to home",
      menu_open: "Open menu",
      menu_close: "Close menu",
    },
    nav: {
      home: "Home",
      about: "About",
      solutions: "Solutions",
      expertise: "Expertise",
      applications: "Applications",
      contact: "Contact",
    },
    hero: {
      eyebrow: "B2B contracting supplier",
      title_line1: "Complete solutions",
      title_line2: "built around",
      title_line3: "glass.",
      subtitle:
        "Specialized contracting supplier for glass, systems and related components in B2B construction projects.",
      paragraph:
        "We work with developers, contractors, architects and designers who need correctly specified, competitive and executable glass-based solutions. We start from glass as the central element and integrate technical consulting, sourcing, products, systems, logistics and implementation support around it.",
      stat_1_value: "B2B",
      stat_1_label: "Specialized contracting",
      stat_2_value: "INT'L",
      stat_2_label: "International sourcing",
      stat_3_value: "360°",
      stat_3_label: "Product · system · support",
      scroll: "Scroll",
    },
    marquee: [
      "Insulating glass",
      "Glazed facades",
      "Aluminium joinery",
      "Balustrades",
      "Laminated glass",
      "Tempered glass",
      "International sourcing",
      "Technical consulting",
      "Partitions",
      "Special glass",
      "Accessories & profiles",
    ],
    about: {
      eyebrow: "Who we are · 01",
      title: "A contracting supplier specialized in glass",
      p1: "GlassCore is a company specialized in glass solutions for construction, addressing the B2B environment. We integrate products, systems and services in a complete approach — from consulting and sourcing through to delivery, coordination and implementation support.",
      p2: "We do not treat glass as a generic commodity. We treat it as a technical material, with direct implications on performance, safety, aesthetics, installation and durability of a building.",
      bullets: [
        "Specialization in glass for construction",
        "Organized international sourcing",
        "Complete solutions, not isolated products",
        "Applied technical consulting",
        "Integration with systems, profiles and accessories",
        "Support for B2B projects",
      ],
    },
    process: {
      eyebrow: "What we do · 02",
      title: "From glass to the complete solution",
      lead: "In construction projects, glass does not operate alone. It must be correlated with the joinery system, facade, fixings, accessories, dimensions, weight, safety requirements, thermal performance, acoustics, solar exposure and the real on-site conditions.",
      lead2:
        "GlassCore integrates these elements into a coherent technical and commercial solution.",
      steps: [
        { t: "Project requirements analysis", d: "We read the technical, commercial and execution context of the project." },
        { t: "Technical consulting", d: "We frame the right questions that avoid incomplete solutions." },
        { t: "Glass & system specification", d: "Compositions, thicknesses, related systems and compatibilities." },
        { t: "Sourcing and optimization", d: "We compare manufacturers, lead times, costs and capacity." },
        { t: "Production and coordination", d: "We align requirements with the reality of partner factories." },
        { t: "Logistics and delivery", d: "Proper handling, packaging and on-site planning." },
        { t: "Installation / implementation support", d: "We back execution and on-site technical clarifications." },
        { t: "Handover and clarifications", d: "Orderly handover with relevant technical documentation." },
      ],
    },
    solutions: {
      eyebrow: "Solutions · 03",
      title: "Glass, systems and components — integrated",
      lead: "Seven core directions through which GlassCore delivers complete solutions built around glass.",
      items: [
        {
          k: "01",
          t: "Insulating glass units",
          d: "Double and triple packs, Low-E, solar control, argon, warm edge, laminated or tempered configurations, tuned to energy, safety and comfort requirements.",
        },
        {
          k: "02",
          t: "Facades and glazed envelopes",
          d: "Facades, curtain walls, large glazings and architectural envelopes — integrating glass, systems and related components.",
        },
        {
          k: "03",
          t: "Aluminium joinery and systems",
          d: "Windows, doors, sliding systems and performance joinery, correlated with glass type, dimensions, weight and project requirements.",
        },
        {
          k: "04",
          t: "Glass balustrades",
          d: "Interior and exterior balustrades with laminated, tempered glass and fixing systems adapted to the application.",
        },
        {
          k: "05",
          t: "Interior partitions",
          d: "Glass partitions, doors, sliding systems and interior solutions for office, retail and residential spaces.",
        },
        {
          k: "06",
          t: "Special glass & custom",
          d: "Extra-clear, low iron, mid iron, tinted, acoustic, solar or special compositions for projects with advanced technical requirements.",
        },
        {
          k: "07",
          t: "Accessories & related components",
          d: "Profiles, fixing systems, hardware, gaskets, beads, spacers, metallic components — everything needed for the complete solution.",
        },
      ],
    },
    expertise: {
      eyebrow: "Technical expertise · 04",
      title: "Glass must be properly specified, not just quoted",
      lead: "A correct glazed solution starts with the right questions: where is it installed, what dimensions, breakage behaviour, thermal performance, solar exposure, safety level, supporting system and how it will be executed on site.",
      lead2:
        "GlassCore helps clients avoid incomplete solutions, product incompatibilities and decisions taken purely on price.",
      topics: [
        "Breakage behaviour",
        "Tempered and laminated glass",
        "Energy efficiency",
        "Solar control",
        "Acoustics",
        "Thicknesses and compositions",
        "Compatibility with joinery",
        "Compatibility with fixing systems",
        "Logistics and handling",
        "Execution feasibility",
      ],
    },
    sourcing: {
      eyebrow: "International sourcing · 05",
      title: "International sourcing and arbitrage across markets",
      p1: "GlassCore works with an international perspective on the glass market and related components. We identify technically and commercially competitive solutions by comparing manufacturers, availability, lead times, costs and production capacity.",
      p2: "This approach lets us build better-calibrated solutions for B2B projects — not just better priced, but better specified, more feasible in production and more suitable for implementation.",
      cards: [
        "Access to specialized manufacturers",
        "Technical and commercial alternatives",
        "Cost / lead time / performance optimization",
        "Production and delivery coordination",
        "Solutions for projects with special requirements",
      ],
    },
    applications: {
      eyebrow: "Applications · 06",
      title: "Applications in construction projects",
      lead: "GlassCore can support projects where glass plays an important architectural, functional or technical role — from insulating glass and joinery to facades, balustrades, partitions and custom applications.",
      items: [
        "Residential developments",
        "Office buildings",
        "Retail spaces",
        "Hotels & hospitality",
        "Restaurants & event venues",
        "Showrooms",
        "Public buildings",
        "Interior fit-outs",
        "Glazed facades",
        "Balustrades & terraces",
        "Premium projects with special requirements",
      ],
    },
    why: {
      eyebrow: "Why GlassCore · 07",
      title: "Six reasons B2B projects choose GlassCore",
      items: [
        { t: "Specialized in glass", d: "We understand the material, the applications and the technical risks." },
        { t: "Contracting approach", d: "We integrate the product, the system, the components, logistics and support." },
        { t: "International sourcing", d: "We search for competitive, feasible solutions across multiple markets." },
        { t: "Technical consulting", d: "We help the client specify the solution properly — not just compare prices." },
        { t: "Practical experience", d: "We understand the difference between quote, production, delivery and site." },
        { t: "Reliable B2B partner", d: "We work in a structured, professional, project-oriented way." },
      ],
    },
    experience: {
      eyebrow: "Experience · 08",
      title: "Relevant Market Experience",
      subtitle:
        "GlassCore represents the scaling of professional maturity built through real experience in projects, quotations, technical consulting, sourcing and specialized deliveries in the architectural glass and construction market.",
      p1: "GlassCore is built on real professional experience accumulated in the market for glass solutions in construction. The team behind GlassCore has interacted over time with developers, contractors, architects, builders and specialized companies in contexts involving quotations, technical consulting, sourcing, specialized deliveries or contracting works.",
      p2: "This experience is now translated into a clearer, more specialized and more complete approach: glass is not treated as an isolated product, but as the central element of an integrated solution that includes systems, components, accessories, logistics and implementation support.",
      p3: "GlassCore expresses this professional evolution: a structure capable of integrating accumulated expertise, market relationships, technical and commercial discipline, and contracting capability into a coherent model for B2B projects involving glass.",
      grid_label: "Relevant professional interactions",
      logos: [
        { name: "Luxuria Residence", src: "/assets/logos/luxuria-mono.png" },
        { name: "One Mircea Eliade", src: "/assets/logos/one-mircea-eliade-mono.png" },
        { name: "Prime Kapital", src: "/assets/logos/prime-kapital-mono.png" },
        { name: "Erbașu", src: "/assets/logos/erbasu-mono.png" },
        { name: "Greenfield Residence", src: "/assets/logos/greenfield-mono.png" },
        { name: "Global Vision", src: "/assets/logos/globalvision-mono.png" },
        { name: "Studium Green", src: "/assets/logos/studium-green-mono.png" },
        { name: "STRABAG", src: "/assets/logos/strabag-mono.png" },
      ],
      disclaimer:
        "The presence of a logo indicates a relevant professional interaction with the team developing GlassCore, in stages such as quotation, technical input, sourcing, specialized delivery or execution. It does not automatically imply a current contractual relationship, an official partnership or commercial endorsement.",
    },
    experience_short: {
      eyebrow: "The experience behind GlassCore",
      title: "The experience behind GlassCore",
      p1: "GlassCore represents the scaling of professional maturity built through real experience in the market for glass solutions in construction. The team has been involved in B2B contexts requiring quotations, technical consulting, sourcing, specialized deliveries and contracting for applications where glass played a technical, architectural or functional role.",
      p2: "This experience is translated into a complete approach: glass as the central element, integrated with systems, components, accessories, logistics and implementation support.",
    },
    final_cta: {
      eyebrow: "Technical discussion · 09",
      title: "Do you have a project involving glass?",
      lead: "Talk to GlassCore before locking the specification, the budget or the supplier. We can review the project requirements and propose a coherent technical and commercial solution.",
      label_email: "Email us",
      label_phone: "Call us",
      hours: "Monday — Friday · 09:00 — 18:00 (EET)",
    },
    footer: {
      tagline: "Complete solutions built around glass.",
      explore: "Navigate",
      contact: "Contact",
      legal: "© {year} GlassCore. All rights reserved.",
      built: "B2B contracting supplier · Glass for construction",
    },
    about_page: {
      eyebrow: "About GlassCore",
      title: "Built around one clear competence: glass for construction.",
      p1: "GlassCore is a company built around one clear competence: glass for construction. Our experience combines real projects, international collaborations, technical sourcing and an understanding of every stage a glazed solution goes through — specification, quoting, production, transport, installation and handover.",
      p2: "This experience lets us operate as a specialized contracting supplier, capable of integrating glass and all related components into a complete solution for the client.",
      principles_title: "Working principles",
      principles: [
        { t: "Technical before commercial", d: "We specify correctly, then optimize commercially — not the other way around." },
        { t: "Solutions, not products", d: "We integrate glass, system, accessories and support." },
        { t: "Execution transparency", d: "We discuss the real site requirements, not just the datasheet." },
        { t: "International sourcing", d: "We compare markets on feasibility, not only price." },
      ],
    },
    solutions_page: {
      eyebrow: "Solutions",
      title: "Glass, systems and components — within one integrated offer.",
      lead: "The categories through which GlassCore delivers complete solutions for B2B construction projects.",
      applications_label: "Applications",
      technical_label: "Technical",
      categories: [
        {
          k: "01",
          t: "Insulating glass units",
          d: "Double and triple packs with Low-E, solar control, argon, warm edge, laminated or tempered configurations.",
          apps: "Residential, offices, hospitality, facades.",
          tech: "Energy performance, light transmission, solar factor g, Uw, acoustic insulation Rw.",
        },
        {
          k: "02",
          t: "Facades and glazed envelopes",
          d: "Glazed facades, curtain walls, large glazings, architectural envelopes integrated with systems and fixings.",
          apps: "Offices, retail, mixed-use, hospitality.",
          tech: "Structural systems, point fixings, profile mounting, seals, drainage.",
        },
        {
          k: "03",
          t: "Aluminium joinery and systems",
          d: "Windows, doors, sliding systems and performance joinery correlated with glass type, weight and dimensions.",
          apps: "Premium residential, offices, hospitality, restaurants.",
          tech: "Thermal break profiles, gaskets, hardware, geometry, statics.",
        },
        {
          k: "04",
          t: "Glass balustrades",
          d: "Interior and exterior balustrades with laminated / tempered-laminated glass and adapted fixing systems.",
          apps: "Terraces, stairs, balconies, mezzanines, hospitality, retail.",
          tech: "Laminated composition, height, line-load, handrail types.",
        },
        {
          k: "05",
          t: "Interior partitions",
          d: "Glass partitions, swing and sliding doors, acoustic solutions for office and retail spaces.",
          apps: "Office, retail, hospitality, premium residential.",
          tech: "Acoustic Rw, fixings, profiles, seals, large openings.",
        },
        {
          k: "06",
          t: "Laminated and tempered glass",
          d: "Solutions for applications with high safety requirements and controlled breakage behaviour.",
          apps: "Balustrades, facades, walkable, anti-burglary, parapets.",
          tech: "PVB / SGP interlayers, resistance classes, residual behaviour after breakage.",
        },
        {
          k: "07",
          t: "Special glass",
          d: "Extra-clear, low iron, mid iron, tinted, acoustic, solar control, special compositions.",
          apps: "Showrooms, premium retail, architectural facades, advanced projects.",
          tech: "Light transmission, chromatic neutrality, solar performance, visual contrast.",
        },
        {
          k: "08",
          t: "Accessories and related components",
          d: "Profiles, fixing systems, hardware, gaskets, beads, spacers, metallic components.",
          apps: "All categories, integrated into the complete solution.",
          tech: "Compatibility, load, fixing, durability, finishes.",
        },
        {
          k: "09",
          t: "Contracting and implementation support",
          d: "Integration of product, system, components, logistics and technical support for execution.",
          apps: "B2B projects where glass plays a significant technical role.",
          tech: "Supplier coordination, phases, technical documentation, on-site clarifications.",
        },
      ],
    },
    expertise_page: {
      eyebrow: "Expertise",
      title: "The right questions produce the right solutions.",
      lead: "A few themes we address technically before any quoting, to reduce on-site risks and decisions made purely on price.",
      topics: [
        {
          t: "How to choose glass correctly",
          d: "We start from application, exposure, dimensions, supporting system and required safety level — not from price per square meter.",
        },
        {
          t: "Breakage behaviour",
          d: "Tempered glass breaks in a controlled way. Laminated glass stays in place. The two are chosen based on application, not the other way around.",
        },
        {
          t: "Tempered, laminated, tempered-laminated",
          d: "Three different behaviours, each suited to a different type of risk: fall, walkability, anti-intrusion, parapets.",
        },
        {
          t: "Compatibility with joinery",
          d: "Profiles, gaskets, weight, geometry and deflections — glass and system must be correlated, not just ordered separately.",
        },
        {
          t: "Thermal, solar, acoustic performance",
          d: "Uw, solar factor g, light transmission, Rw — real parameters that influence comfort and consumption.",
        },
        {
          t: "Technical sourcing vs. simple procurement",
          d: "Technical sourcing compares markets on specification, capacity, lead time and feasibility — not only on price.",
        },
        {
          t: "Why a complete solution reduces risk",
          d: "Glass, system, accessories and support combined in a single offer eliminate the classic incompatibilities.",
        },
      ],
      questions_title: "Typical technical questions",
      questions: [
        "Where is the glazing installed and what is the exposure?",
        "What dimensions and weights are involved?",
        "What breakage behaviour is required?",
        "Are there acoustic or solar control requirements?",
        "What joinery or fixing system is used?",
        "How is it handled and installed on site?",
      ],
    },
    contact_page: {
      eyebrow: "Contact",
      title: "A technical discussion, not just a quote request.",
      lead: "For technical inquiries or B2B projects, share as much information as possible about the application, dimensions, system, deadline and available documentation. We respond quickly, in a structured way, relevant to your project context.",
      email_label: "Email",
      phone_label: "Phone",
      address_label: "Address",
      hours_label: "Hours",
      hours_value: "Monday — Friday · 09:00 — 18:00 (EET)",
      address_value: "Oradea, Str. Roman Ciorogariu 65, Corp C, Etaj 2, 410009, Romania",
      checklist_title: "What helps in a first discussion",
      checklist: [
        "Project type (residential, office, hospitality, retail, public)",
        "Stage (permit, technical, execution, tendering)",
        "Applications (facade, joinery, balustrade, partition, custom)",
        "Indicative dimensions and quantities",
        "Performance requirements (thermal, solar, acoustic, safety)",
        "Target deadlines and site constraints",
        "Available documentation (drawings, details, specifications)",
      ],
    },
    seo: {
      home_title: "GlassCore — Complete solutions built around glass | B2B contracting supplier",
      home_desc:
        "GlassCore is a specialized contracting supplier for glass solutions in construction: insulating glass, facades, aluminium joinery, balustrades and special glass for B2B projects.",
      about_title: "About GlassCore — Specialized glass supplier for construction",
      about_desc:
        "A company specialized in glass solutions for B2B construction projects. International sourcing, technical consulting, product integration and implementation support.",
      solutions_title: "GlassCore Solutions — Glass, facades, joinery, balustrades, special glass",
      solutions_desc:
        "Insulating glass, glazed facades, aluminium joinery, balustrades, partitions, laminated, tempered and special glass for B2B projects.",
      expertise_title: "Expertise — GlassCore | Glass properly specified, not just quoted",
      expertise_desc:
        "How to choose glass correctly, breakage behaviour, thermal, solar and acoustic performance, system compatibility and implementation support.",
      contact_title: "Contact GlassCore — Technical discussion for B2B glass projects",
      contact_desc:
        "Contact GlassCore for B2B projects involving glass. Email office@glasscore.ro, phone +40 723 347 165.",
    },
  },
  tr: {
    common: {
      brand: "GlassCore",
      cta_primary: "Teknik görüşme talep edin",
      cta_specialist: "Bir uzmanla görüşün",
      cta_solutions: "GlassCore çözümlerini keşfedin",
      cta_discuss: "Bu çözümü GlassCore ile görüşün",
      cta_short: "GlassCore ile görüşün",
      lang_ro: "RO",
      lang_en: "EN",
      lang_tr: "TR",
      email: "office@glasscore.ro",
      phone: "+40 723 347 165",
      phone_href: "tel:+40723347165",
      address_placeholder: "[şirket adresi]",
      back_home: "Ana sayfaya dön",
      menu_open: "Menüyü aç",
      menu_close: "Menüyü kapat",
    },
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      solutions: "Çözümler",
      expertise: "Uzmanlık",
      applications: "Uygulamalar",
      contact: "İletişim",
    },
    hero: {
      eyebrow: "B2B müteahhitlik tedarikçisi",
      title_line1: "Camın etrafında",
      title_line2: "inşa edilen",
      title_line3: "eksiksiz çözümler.",
      subtitle:
        "B2B inşaat projeleri için cam, sistemler ve ilgili bileşenlerde uzmanlaşmış müteahhitlik tedarikçisi.",
      paragraph:
        "Doğru şekilde belirlenmiş, rekabetçi ve uygulanabilir cam çözümlerine ihtiyaç duyan geliştiriciler, müteahhitler, mimarlar ve tasarımcılarla birlikte çalışıyoruz. Camı merkeze koyup etrafına teknik danışmanlık, tedarik, ürünler, sistemler, lojistik ve uygulama desteğini entegre ediyoruz.",
      stat_1_value: "B2B",
      stat_1_label: "Uzman müteahhitlik",
      stat_2_value: "INT'L",
      stat_2_label: "Uluslararası tedarik",
      stat_3_value: "360°",
      stat_3_label: "Ürün · sistem · destek",
      scroll: "Kaydır",
    },
    marquee: [
      "İzolasyonlu cam",
      "Camlı cepheler",
      "Alüminyum doğrama",
      "Korkuluklar",
      "Lamine cam",
      "Temperli cam",
      "Uluslararası tedarik",
      "Teknik danışmanlık",
      "Bölme duvarlar",
      "Özel cam",
      "Aksesuar ve profiller",
    ],
    about: {
      eyebrow: "Biz kimiz · 01",
      title: "Camda uzmanlaşmış müteahhitlik tedarikçisi",
      p1: "GlassCore, B2B ortamına yönelik, inşaat için cam çözümlerinde uzmanlaşmış bir şirkettir. Ürün, sistem ve hizmetleri eksiksiz bir yaklaşımla entegre ediyoruz: danışmanlık ve tedarikten teslimat, koordinasyon ve uygulama desteğine kadar.",
      p2: "Camı jenerik bir mal olarak değil, bir yapının performansı, güvenliği, estetiği, montajı ve dayanıklılığı üzerinde doğrudan etkileri olan teknik bir malzeme olarak ele alıyoruz.",
      bullets: [
        "İnşaat için camda uzmanlaşma",
        "Organize uluslararası tedarik",
        "Eksiksiz çözümler, izole ürünler değil",
        "Uygulamalı teknik danışmanlık",
        "Sistemler, profiller ve aksesuarlarla entegrasyon",
        "B2B projeleri için destek",
      ],
    },
    process: {
      eyebrow: "Ne yapıyoruz · 02",
      title: "Camdan eksiksiz çözüme",
      lead: "İnşaat projelerinde cam tek başına çalışmaz. Doğrama sistemi, cephe, bağlantılar, aksesuarlar, ölçüler, ağırlık, güvenlik gereksinimleri, ısı performansı, akustik, güneş maruziyeti ve gerçek şantiye koşullarıyla ilişkilendirilmelidir.",
      lead2: "GlassCore bu unsurları tutarlı bir teknik ve ticari çözüm içinde entegre eder.",
      steps: [
        { t: "Proje gereksinim analizi", d: "Projenin teknik, ticari ve uygulama bağlamını okuyoruz." },
        { t: "Teknik danışmanlık", d: "Eksik çözümlerden kaçınacak doğru soruları soruyoruz." },
        { t: "Cam ve sistem şartnamesi", d: "Bileşimler, kalınlıklar, ilgili sistemler ve uyumluluklar." },
        { t: "Tedarik ve optimizasyon", d: "Üreticileri, teslim sürelerini, maliyetleri ve kapasiteyi karşılaştırıyoruz." },
        { t: "Üretim ve koordinasyon", d: "Gereksinimleri partner fabrikaların gerçekliğiyle hizalıyoruz." },
        { t: "Lojistik ve teslimat", d: "Doğru elleçleme, paketleme ve şantiye planlaması." },
        { t: "Montaj / uygulama desteği", d: "Şantiyedeki uygulama ve teknik açıklamaları destekliyoruz." },
        { t: "Teslim ve açıklamalar", d: "İlgili teknik dokümantasyonla düzenli teslim." },
      ],
    },
    solutions: {
      eyebrow: "Çözümler · 03",
      title: "Cam, sistemler ve bileşenler — entegre",
      lead: "GlassCore'un cam etrafında eksiksiz çözümler sunduğu yedi ana yön.",
      items: [
        {
          k: "01",
          t: "İzolasyonlu cam üniteleri",
          d: "Enerji, güvenlik ve konfor gereksinimlerine göre ayarlanmış Low-E, güneş kontrolü, argon, warm edge, lamine veya temperli konfigürasyonlarla çift ve üçlü paketler.",
        },
        {
          k: "02",
          t: "Cepheler ve camlı kabuklar",
          d: "Cam, sistemler ve ilgili bileşenleri entegre eden cepheler, giydirme cepheler, büyük camlıklar ve mimari kabuklar.",
        },
        {
          k: "03",
          t: "Alüminyum doğrama ve sistemler",
          d: "Cam türü, ölçüler, ağırlık ve proje gereksinimleriyle ilişkilendirilmiş pencereler, kapılar, sürgülü sistemler ve yüksek performanslı doğramalar.",
        },
        {
          k: "04",
          t: "Cam korkuluklar",
          d: "Uygulamaya uygun lamine, temperli cam ve sabitleme sistemleriyle iç ve dış korkuluklar.",
        },
        {
          k: "05",
          t: "İç mekan bölmeleri",
          d: "Ofis, perakende ve konut alanları için cam bölmeler, kapılar, sürgülü sistemler ve iç mekan çözümleri.",
        },
        {
          k: "06",
          t: "Özel cam ve özel uygulamalar",
          d: "İleri teknik gereksinimli projeler için ekstra şeffaf, düşük demirli, orta demirli, renkli, akustik, güneş veya özel bileşimler.",
        },
        {
          k: "07",
          t: "Aksesuar ve ilgili bileşenler",
          d: "Profiller, sabitleme sistemleri, donanım, contalar, ara çıtalar, mesafe tutucular, metalik parçalar — eksiksiz çözüm için gerekli her şey.",
        },
      ],
    },
    expertise: {
      eyebrow: "Teknik uzmanlık · 04",
      title: "Cam yalnızca teklif edilmez, doğru şekilde belirlenmelidir",
      lead: "Doğru bir camlı çözüm doğru sorularla başlar: nereye monte ediliyor, hangi ölçüler, kırılma davranışı, ısı performansı, güneş maruziyeti, güvenlik seviyesi, destek sistemi ve şantiyede nasıl uygulanacak.",
      lead2:
        "GlassCore, müşterilerin eksik çözümlerden, ürün uyumsuzluklarından ve yalnızca fiyat üzerinden alınan kararlardan kaçınmasına yardımcı olur.",
      topics: [
        "Kırılma davranışı",
        "Temperli ve lamine cam",
        "Enerji verimliliği",
        "Güneş kontrolü",
        "Akustik",
        "Kalınlıklar ve bileşimler",
        "Doğramayla uyumluluk",
        "Sabitleme sistemleriyle uyumluluk",
        "Lojistik ve elleçleme",
        "Uygulama fizibilitesi",
      ],
    },
    sourcing: {
      eyebrow: "Uluslararası tedarik · 05",
      title: "Uluslararası tedarik ve piyasalar arası arbitraj",
      p1: "GlassCore, cam piyasasına ve ilgili bileşenlere uluslararası bir perspektifle bakar. Üreticileri, mevcudiyeti, teslim sürelerini, maliyetleri ve üretim kapasitesini karşılaştırarak teknik ve ticari açıdan rekabetçi çözümler belirliyoruz.",
      p2: "Bu yaklaşım, B2B projeleri için daha iyi kalibre edilmiş çözümler oluşturmamıza olanak tanır: sadece fiyat olarak değil, şartname olarak daha net, üretimde daha uygulanabilir ve uygulamaya daha uygun.",
      cards: [
        "Uzman üreticilere erişim",
        "Teknik ve ticari alternatifler",
        "Maliyet / teslim / performans optimizasyonu",
        "Üretim ve teslimat koordinasyonu",
        "Özel gereksinimli projeler için çözümler",
      ],
    },
    applications: {
      eyebrow: "Uygulamalar · 06",
      title: "İnşaat projelerinde uygulamalar",
      lead: "GlassCore, camın önemli bir mimari, işlevsel veya teknik rol oynadığı projeleri destekleyebilir — izolasyonlu cam ve doğramalardan cephelere, korkuluklara, bölmelere ve özel uygulamalara kadar.",
      items: [
        "Konut projeleri",
        "Ofis binaları",
        "Ticari alanlar",
        "Oteller ve konaklama",
        "Restoranlar ve etkinlik salonları",
        "Showroom'lar",
        "Kamu binaları",
        "İç mekan tasarımları",
        "Camlı cepheler",
        "Korkuluklar ve teraslar",
        "Özel gereksinimli premium projeler",
      ],
    },
    why: {
      eyebrow: "Neden GlassCore · 07",
      title: "B2B projelerinin GlassCore'u seçmesinin altı nedeni",
      items: [
        { t: "Camda uzmanlaşma", d: "Malzemeyi, uygulamaları ve teknik riskleri anlıyoruz." },
        { t: "Müteahhitlik yaklaşımı", d: "Ürün, sistem, bileşenler, lojistik ve desteği entegre ediyoruz." },
        { t: "Uluslararası tedarik", d: "Birden fazla piyasada rekabetçi, uygulanabilir çözümler arıyoruz." },
        { t: "Teknik danışmanlık", d: "Müşteriye çözümü doğru şekilde belirtmesinde yardımcı oluyoruz — sadece fiyat karşılaştırmasında değil." },
        { t: "Pratik deneyim", d: "Teklif, üretim, teslimat ve şantiye arasındaki farkı biliyoruz." },
        { t: "Güvenilir B2B iş ortağı", d: "Yapılandırılmış, profesyonel ve proje odaklı çalışıyoruz." },
      ],
    },
    experience: {
      eyebrow: "Deneyim · 08",
      title: "İlgili piyasa deneyimi",
      subtitle:
        "GlassCore; projelerde, tekliflerde, teknik danışmanlıkta, tedarikte ve mimari cam ile inşaat piyasasındaki uzman teslimatlarda edinilen gerçek deneyim üzerinden inşa edilen profesyonel olgunluğun ölçeklendirilmesini temsil eder.",
      p1: "GlassCore, inşaat için cam çözümleri piyasasında birikmiş gerçek profesyonel deneyim üzerine kurulmuştur. GlassCore'un arkasındaki ekip; teklif, teknik danışmanlık, tedarik, uzman teslimatlar veya müteahhitlik işlerini içeren bağlamlarda geliştiriciler, müteahhitler, mimarlar, inşaatçılar ve uzman şirketlerle etkileşim kurmuştur.",
      p2: "Bu deneyim bugün daha net, daha uzmanlaşmış ve daha eksiksiz bir yaklaşıma dönüştürülüyor: cam, sistemler, bileşenler, aksesuarlar, lojistik ve uygulama desteğini içeren entegre bir çözümün merkezi unsuru olarak ele alınıyor.",
      p3: "GlassCore bu profesyonel evrimi ifade eder: birikmiş uzmanlığı, piyasa ilişkilerini, teknik-ticari disiplini ve müteahhitlik kabiliyetini cam içeren B2B projeler için tutarlı bir modelde entegre edebilen bir yapı.",
      grid_label: "İlgili profesyonel etkileşimler",
      logos: [
        { name: "Luxuria Residence", src: "/assets/logos/luxuria-mono.png" },
        { name: "One Mircea Eliade", src: "/assets/logos/one-mircea-eliade-mono.png" },
        { name: "Prime Kapital", src: "/assets/logos/prime-kapital-mono.png" },
        { name: "Erbașu", src: "/assets/logos/erbasu-mono.png" },
        { name: "Greenfield Residence", src: "/assets/logos/greenfield-mono.png" },
        { name: "Global Vision", src: "/assets/logos/globalvision-mono.png" },
        { name: "Studium Green", src: "/assets/logos/studium-green-mono.png" },
        { name: "STRABAG", src: "/assets/logos/strabag-mono.png" },
      ],
      disclaimer:
        "Bir logonun burada yer alması, GlassCore'u geliştiren ekiple teklif, teknik girdi, tedarik, uzman teslimat veya uygulama gibi aşamalarda yaşanan ilgili profesyonel bir etkileşimi gösterir. Bu, otomatik olarak mevcut bir sözleşmesel ilişki, resmi bir ortaklık veya ticari tavsiye anlamına gelmez.",
    },
    experience_short: {
      eyebrow: "GlassCore'un arkasındaki deneyim",
      title: "GlassCore'un arkasındaki deneyim",
      p1: "GlassCore, inşaat için cam çözümleri piyasasında edinilen gerçek deneyimden doğan profesyonel olgunluğun ölçeklendirilmesini temsil eder. Ekip, camın teknik, mimari veya işlevsel bir rol oynadığı uygulamalar için teklif, teknik danışmanlık, tedarik, uzman teslimatlar ve müteahhitlik gerektiren B2B bağlamlarında yer almıştır.",
      p2: "Bu deneyim eksiksiz bir yaklaşıma dönüştürülüyor: sistemler, bileşenler, aksesuarlar, lojistik ve uygulama desteğiyle entegre edilmiş merkezi unsur olarak cam.",
    },
    final_cta: {
      eyebrow: "Teknik görüşme · 09",
      title: "Cam içeren bir projeniz mi var?",
      lead: "Şartnameyi, bütçeyi veya tedarikçiyi kesinleştirmeden önce GlassCore ile görüşün. Proje gereksinimlerini inceleyip tutarlı bir teknik ve ticari çözüm önerebiliriz.",
      label_email: "Bize yazın",
      label_phone: "Bizi arayın",
      hours: "Pazartesi — Cuma · 09:00 — 18:00 (EET)",
    },
    footer: {
      tagline: "Camın etrafında inşa edilen eksiksiz çözümler.",
      explore: "Gezinti",
      contact: "İletişim",
      legal: "© {year} GlassCore. Tüm hakları saklıdır.",
      built: "B2B müteahhitlik tedarikçisi · İnşaat için cam",
    },
    about_page: {
      eyebrow: "GlassCore Hakkında",
      title: "Tek bir net yetkinlik üzerine kurulu: inşaat için cam.",
      p1: "GlassCore, tek bir net yetkinlik üzerine kurulmuş bir şirkettir: inşaat için cam. Deneyimimiz gerçek projeleri, uluslararası işbirliklerini, teknik tedariki ve camlı bir çözümün geçtiği her aşamayı — şartname, teklif, üretim, taşıma, montaj ve teslim — anlamayı bir araya getirir.",
      p2: "Bu deneyim, cam ve tüm ilgili bileşenleri müşteri için eksiksiz bir çözüme entegre edebilen uzman bir müteahhitlik tedarikçisi olarak çalışmamıza olanak tanır.",
      principles_title: "Çalışma prensipleri",
      principles: [
        { t: "Teknik önce, ticari sonra", d: "Doğru şekilde belirtiyoruz, sonra ticari olarak optimize ediyoruz — tersini değil." },
        { t: "Çözümler, ürünler değil", d: "Cam, sistem, aksesuar ve desteği entegre ediyoruz." },
        { t: "Uygulama şeffaflığı", d: "Sadece teknik föyü değil, gerçek şantiye gereksinimlerini görüşüyoruz." },
        { t: "Uluslararası tedarik", d: "Piyasaları sadece fiyat değil, uygulanabilirlik üzerinden karşılaştırıyoruz." },
      ],
    },
    solutions_page: {
      eyebrow: "Çözümler",
      title: "Cam, sistemler ve bileşenler — entegre tek bir teklifte.",
      lead: "GlassCore'un B2B inşaat projeleri için eksiksiz çözümler sunduğu kategoriler.",
      applications_label: "Uygulamalar",
      technical_label: "Teknik",
      categories: [
        {
          k: "01",
          t: "İzolasyonlu cam üniteleri",
          d: "Low-E, güneş kontrolü, argon, warm edge, lamine veya temperli konfigürasyonlarla çift ve üçlü paketler.",
          apps: "Konut, ofisler, konaklama, cepheler.",
          tech: "Enerji performansı, ışık geçirgenliği, güneş faktörü g, Uw, akustik yalıtım Rw.",
        },
        {
          k: "02",
          t: "Cepheler ve camlı kabuklar",
          d: "Sistemler ve sabitlemelerle entegre camlı cepheler, giydirme cepheler, büyük camlıklar, mimari kabuklar.",
          apps: "Ofisler, perakende, karma kullanım, konaklama.",
          tech: "Yapısal sistemler, nokta bağlantılar, profil montajı, contalar, drenaj.",
        },
        {
          k: "03",
          t: "Alüminyum doğrama ve sistemler",
          d: "Cam türü, ağırlığı ve ölçüleriyle ilişkilendirilmiş pencereler, kapılar, sürgülü sistemler ve yüksek performanslı doğramalar.",
          apps: "Premium konut, ofisler, konaklama, restoranlar.",
          tech: "Isı yalıtımlı profiller, contalar, donanım, geometri, statik.",
        },
        {
          k: "04",
          t: "Cam korkuluklar",
          d: "Lamine / temperli-lamine cam ve uygun sabitleme sistemleriyle iç ve dış korkuluklar.",
          apps: "Teraslar, merdivenler, balkonlar, ara katlar, konaklama, perakende.",
          tech: "Lamine bileşim, yükseklik, hat yükü, küpeşte türleri.",
        },
        {
          k: "05",
          t: "İç mekan bölmeleri",
          d: "Ofis ve perakende alanları için cam bölmeler, açılır ve sürgülü kapılar, akustik çözümler.",
          apps: "Ofis, perakende, konaklama, premium konut.",
          tech: "Akustik Rw, sabitleme, profiller, contalar, geniş açıklıklar.",
        },
        {
          k: "06",
          t: "Lamine ve temperli cam",
          d: "Yüksek güvenlik gereksinimli ve kontrollü kırılma davranışlı uygulamalar için çözümler.",
          apps: "Korkuluklar, cepheler, üzerinde yürünebilir, hırsızlık önleyici, parapetler.",
          tech: "PVB / SGP ara katmanlar, mukavemet sınıfları, kırılma sonrası davranış.",
        },
        {
          k: "07",
          t: "Özel cam",
          d: "Ekstra şeffaf, düşük demirli, orta demirli, renkli, akustik, güneş kontrolü, özel bileşimler.",
          apps: "Showroom'lar, premium perakende, mimari cepheler, ileri projeler.",
          tech: "Işık geçirgenliği, kromatik nötrlük, güneş performansı, görsel kontrast.",
        },
        {
          k: "08",
          t: "Aksesuar ve ilgili bileşenler",
          d: "Profiller, sabitleme sistemleri, donanım, contalar, ara çıtalar, mesafe tutucular, metalik parçalar.",
          apps: "Tüm kategoriler, eksiksiz çözüme entegre.",
          tech: "Uyumluluk, yük, sabitleme, dayanıklılık, kaplamalar.",
        },
        {
          k: "09",
          t: "Müteahhitlik ve uygulama desteği",
          d: "Uygulama için ürün, sistem, bileşen, lojistik ve teknik desteğin entegrasyonu.",
          apps: "Camın önemli teknik rol oynadığı B2B projeler.",
          tech: "Tedarikçi koordinasyonu, aşamalar, teknik dokümantasyon, şantiye açıklamaları.",
        },
      ],
    },
    expertise_page: {
      eyebrow: "Uzmanlık",
      title: "Doğru sorular doğru çözümleri üretir.",
      lead: "Şantiye risklerini ve yalnızca fiyata dayalı kararları azaltmak için herhangi bir tekliften önce teknik olarak ele aldığımız bazı konular.",
      topics: [
        {
          t: "Cam nasıl doğru seçilir",
          d: "Metrekare fiyatından değil; uygulama, maruziyet, ölçüler, destek sistemi ve gerekli güvenlik seviyesinden başlıyoruz.",
        },
        {
          t: "Kırılma davranışı",
          d: "Temperli cam kontrollü şekilde kırılır. Lamine cam yerinde kalır. Bu ikisi uygulamaya göre seçilir, tersine değil.",
        },
        {
          t: "Temperli, lamine, temperli-lamine",
          d: "Üç farklı davranış, her biri farklı bir risk türüne uygun: düşme, üzerinde yürünme, hırsızlık önleme, parapetler.",
        },
        {
          t: "Doğramayla uyumluluk",
          d: "Profiller, contalar, ağırlık, geometri ve sehim — cam ve sistem ayrı sipariş edilmemeli, ilişkilendirilmelidir.",
        },
        {
          t: "Isıl, güneş, akustik performans",
          d: "Uw, güneş faktörü g, ışık geçirgenliği, Rw — konforu ve tüketimi etkileyen gerçek parametreler.",
        },
        {
          t: "Teknik tedarik vs. basit satın alma",
          d: "Teknik tedarik piyasaları sadece fiyat üzerinden değil; şartname, kapasite, teslim süresi ve fizibilite üzerinden karşılaştırır.",
        },
        {
          t: "Eksiksiz çözüm neden riski azaltır",
          d: "Cam, sistem, aksesuar ve destek tek bir teklifte birleştirildiğinde klasik uyumsuzluklar ortadan kalkar.",
        },
      ],
      questions_title: "Tipik teknik sorular",
      questions: [
        "Camlama nereye monte edilir ve maruziyet nedir?",
        "Hangi ölçüler ve ağırlıklar söz konusu?",
        "Hangi kırılma davranışı gerekli?",
        "Akustik veya güneş kontrolü gereksinimleri var mı?",
        "Hangi doğrama veya sabitleme sistemi kullanılıyor?",
        "Şantiyede nasıl elleçleniyor ve monte ediliyor?",
      ],
    },
    contact_page: {
      eyebrow: "İletişim",
      title: "Sadece bir teklif isteği değil, teknik bir görüşme.",
      lead: "Teknik sorular veya B2B projeleri için uygulama, ölçüler, sistem, son tarih ve mevcut dokümantasyon hakkında mümkün olduğunca çok bilgi paylaşın. Proje bağlamınıza uygun, hızlı ve yapılandırılmış şekilde yanıt veriyoruz.",
      email_label: "E-posta",
      phone_label: "Telefon",
      address_label: "Adres",
      hours_label: "Çalışma saatleri",
      hours_value: "Pazartesi — Cuma · 09:00 — 18:00 (EET)",
      address_value: "Oradea, Str. Roman Ciorogariu 65, Corp C, Etaj 2, 410009, Romania",
      checklist_title: "İlk görüşmede neye yardımcı olur",
      checklist: [
        "Proje türü (konut, ofis, konaklama, perakende, kamu)",
        "Aşama (izin, teknik, uygulama, ihale)",
        "Uygulamalar (cephe, doğrama, korkuluk, bölme, özel)",
        "İndikatif ölçüler ve miktarlar",
        "Performans gereksinimleri (ısıl, güneş, akustik, güvenlik)",
        "Hedef son tarihler ve şantiye kısıtları",
        "Mevcut dokümantasyon (çizimler, detaylar, şartnameler)",
      ],
    },
    seo: {
      home_title: "GlassCore — Camın etrafında inşa edilen eksiksiz çözümler | B2B müteahhitlik tedarikçisi",
      home_desc:
        "GlassCore, inşaatta cam çözümleri için uzmanlaşmış bir müteahhitlik tedarikçisidir: izolasyonlu cam, cepheler, alüminyum doğrama, korkuluklar ve B2B projeleri için özel cam.",
      about_title: "GlassCore Hakkında — İnşaat için uzman cam tedarikçisi",
      about_desc:
        "B2B inşaat projeleri için cam çözümlerinde uzmanlaşmış bir şirket. Uluslararası tedarik, teknik danışmanlık, ürün entegrasyonu ve uygulama desteği.",
      solutions_title: "GlassCore Çözümleri — Cam, cepheler, doğrama, korkuluklar, özel cam",
      solutions_desc:
        "B2B projeleri için izolasyonlu cam, camlı cepheler, alüminyum doğrama, korkuluklar, bölmeler, lamine, temperli ve özel cam.",
      expertise_title: "Uzmanlık — GlassCore | Cam doğru şekilde belirtilir, yalnızca teklif edilmez",
      expertise_desc:
        "Camın nasıl doğru seçileceği, kırılma davranışı, ısıl, güneş ve akustik performans, sistem uyumluluğu ve uygulama desteği.",
      contact_title: "GlassCore İletişim — B2B cam projeleri için teknik görüşme",
      contact_desc:
        "Cam içeren B2B projeler için GlassCore ile iletişime geçin. E-posta office@glasscore.ro, telefon +40 723 347 165.",
    },
  },
};
